import { Menu, MenuButton, MenuList, MenuItem, Button, Flex } from "@chakra-ui/react"
import { DeletUser } from "./_deletar_usuario"

import { EditarUsuario } from "./_editar_usuarios"

export const MenuListUser = ({ user }) => {

    return (
        <Menu>
            <MenuButton backgroundColor="white" borderRadius="8px" as={Button} size="xs" pb={2} >
                <Flex
                    align="center"
                    justify="center"
                    w="100%"
                    h="100%"
                >
                    ...
                </Flex>
            </MenuButton>
            <MenuList
                _hover={{
                    backgroundColor: "gray.50",
                    cursor: "pointer"
                }}
            >

                <EditarUsuario user={user} />
                {/* <DeletUser user={user} /> */}
            </MenuList>
        </Menu>
    )
}


